var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2V19C1 21.2123 2.78772 23 5 23H22C22.5523 23 23 22.5523 23 22C23 21.4477 22.5523 21 22 21H5C3.89228 21 3 20.1077 3 19V2Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7595 7.65056C22.1187 7.23112 22.07 6.59984 21.6506 6.24054C21.2311 5.88125 20.5998 5.93001 20.2405 6.34944L15.6432 11.7164L15.642 11.7177C15.2605 12.1579 14.5847 12.1805 14.1771 11.7729L13.229 10.8248C11.9902 9.57361 9.9658 9.67493 8.83318 10.9864L8.83044 10.9896L4.24044 16.3496C3.88122 16.769 3.93007 17.4003 4.34956 17.7596C4.76905 18.1188 5.40033 18.0699 5.75956 17.6504L10.3468 12.2936L10.348 12.2923C10.7348 11.8459 11.4076 11.8269 11.8086 12.2328L11.8129 12.2371L12.7629 13.1871C13.9949 14.4191 16.0181 14.3421 17.1568 13.0236L17.1595 13.0206L21.7595 7.65056Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.bb379375c82d306b30ee03cabedc6853.svg";
export { ForwardRef as ReactComponent };